import { FeedbackType } from '@chegg-wt/core-wa/types'

export const PRIORITY_200 = 200

export const SCORECARD_BASE_PERCENTAGE = 40
export const IS_NON_MANUAL_TEXT_UPDATE = 'isNonManualTextUpdate'
export const NON_MANUAL_UPDATE_TYPE = 'nonManualUpdateType'
export const IS_HISTORY_CHANGE = 'isHistoryChange'

export const feedbackTypeRequiresNoRecheck = [
  FeedbackType.PARAPHRASE,
  FeedbackType.REWRITE,
]
